import axios from "axios";
import Data from "../../Data/Data.json"

import { Crypter } from "../Security/Crypter";
import { BilletageItem } from "../../Components/Billetage";

  export const InitBilletage = async (props:{authHeader : any, form: any, value : string, second?: boolean}) => {
    try {
      const config = {
        method: 'get',
        url: Data.ApiUrl.GetBilletage,
        headers: {
          'Authorization': props.authHeader,
          'Content-Type': 'application/json',
          'CypherSearch': Crypter.encrypt("")
        }
      };
      const response = await axios.request(config);
      const res = JSON.parse(Crypter.decrypt(response.data)).Value;

      if (res.StatutCode === 200) {
        const data: BilletageItem[] = res.Result.Table || [];
        // filtrer les actifs
        const activeData = data.filter(item => item.ISActif);

        activeData.map((b:BilletageItem)=>{
            props.form.setFieldValue((b.Code)+(props.second? "_1": ""), props.value)
        })
      }
    } catch {
    } finally {
    }
  };